export default __webpack_public_path__ + "static/media/bussines-management-360devpro.a7a56529.svg";